"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onWaiting;
function onWaiting(event) {
  clearTimeout(this._timeUpdateInterval);
  clearTimeout(this._hideSpinnerInterval);
  this._showSpinnerWithDelay();
  if (this.rawPlayer.seeking !== true) {
    this.logger.times.BufferTime = performance.now();
  } else {
    this.logger.times.BufferTime = 0;
  }
  this.emit('waiting', event);
}